module.exports = __webpack_public_path__ + "static/media/heartbeat.6dc2970b.svg";